import {injectable} from "inversify";
import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {AfterSeasonEvaluationEvent} from "@/modules/season/events/AfterSeasonEvaluationEvent";
import {Player} from "@/modules/team/entity";

@injectable()
export default class TransferStatusEventSubscriber implements EventSubscriber {
  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterSeasonEvaluationEvent, callback: this.onAfterSeasonEvaluationEvent},
    ];
  }

  priority(): number {
    return 0;
  }

  public async onAfterSeasonEvaluationEvent(event: AfterSeasonEvaluationEvent) {
    await Player
      .createQueryBuilder('player')
      .update()
      .set({
        transferred: false,
      })
      .execute();
  }
}
